import { ExternalLink, Map as MapIcon } from 'lucide-react';
import { Chip } from '@/ui/primitives';
import { formatRelative } from '@/lib/format';
import { labelVerificacao, mapTargetFor, statusTone } from '../data';
import type { Verification } from '../schemas';

interface Props {
  verification: Verification;
  cpf: string;
  imovelId?: string | null;
}

export function VerificationRow({ verification: v, cpf, imovelId = null }: Props) {
  const tone = statusTone(v.status);
  const label = labelVerificacao(v.verificacao);
  const target = mapTargetFor(v.verificacao, cpf, imovelId);

  return (
    <li className="flex flex-col gap-1 py-2.5 border-b border-border last:border-0">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-sm font-medium text-text">{label}</span>
        <Chip tone={tone} size="sm" dot>
          {v.status}
        </Chip>
        {target && (
          <a
            href={target.url}
            target="_blank"
            rel="noreferrer"
            title={target.label}
            className="chip chip-blue inline-flex items-center gap-1 text-[0.7rem] no-underline hover:opacity-80 transition-opacity"
          >
            <MapIcon size={11} strokeWidth={1.5} />
            Ver Mapa
          </a>
        )}
      </div>

      {v.detalhe && <p className="text-xs text-text-2">{v.detalhe}</p>}

<div className="flex items-center gap-3 text-[10px] text-text-muted">
        {v.verificado_em && <span>Verificado {formatRelative(v.verificado_em)}</span>}
        {v.fonte_url && (
          <a
            href={v.fonte_url}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 text-accent hover:underline"
          >
            Fonte
            <ExternalLink size={10} strokeWidth={1.5} />
          </a>
        )}
      </div>
    </li>
  );
}
